//imports
import { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteIcon from "@mui/icons-material/Delete";
import Snackbar from "@mui/material/Snackbar";
import {
  currencyFormat
} from "../../../src/utils/common/CurrencyFormat";
import Alert from "@mui/material/Alert";
import {
  Box,
  Grid,
  Button,
  TextField,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Breadcrumbs,
  Link, Stack,
  Paper,
  IconButton,
  Autocomplete,
  Typography,
  Tooltip
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Navbar from "../../components/common/Navbar";
import AppBar from "@mui/material/AppBar";
import { useNavigate } from "react-router-dom";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  externalgetApi,
  externalImagepostApi,
  externalpostApi,
} from "../../services/external/externalApis";
import {
  CUSTOMER_API_01,
  STOCK_API_01, COMMON_API_02, FILE_API_01
} from "../../api/ApiModel";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import {
  CON_STATUS_ACTIVE, CON_DEF_WAITING_TIME
} from "../../utils/sys/Constants";
import useDisableButton from "../../hooks/useDisableButton";
import { FILESERVERURL } from "../../config/Config";

export default function StockAside() {
  //hooks
  const theme = useTheme();
  const styles = useStyles(theme);
  const [fieldErrors, setFieldErrors] = useState({});
  const [fieldErrors1, setFieldErrors1] = useState({});
  const [data, setData] = useState(null);
  const [data1, setData1] = useState(null);
  const [error, setError] = useState(null);
  const [error1, setError1] = useState(null);
  const [error2, setError2] = useState(null);
  const [error3, setError3] = useState(null);
  const [error4, setError4] = useState(null);
  const [error5, setError5] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const [selectedItem, setSelectedItem] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const { disabled, handleDisable } = useDisableButton(CON_DEF_WAITING_TIME);
  const [filePath, setFilePath] = useState("");

  const [formData, setFormData] = useState({
    SUPREFCODE: "",
    supplier: "",
    invoiceDate: "",
    invoiceNo: "",
    item: "",
    cost: "",
    sellPrice: "",
    expiry: "",
    quantity: "",
    tax: 0,
    discount: 0,
    filepath: null,
  });
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const savedData = sessionStorage.getItem("stockTableData");
    if (savedData) {
      setTableData(JSON.parse(savedData));
    }
  }, []);

  useEffect(() => {
    fetchDataComman();
    fetchDatacustom();
  }, []);

  //post API
  const handleAddClick = () => {
    // List of required fields
    const requiredFields = [
      { name: "item", value: formData.item, label: "Item" },
      { name: "cost", value: formData.cost, label: "Cost" },
      { name: "sellPrice", value: formData.sellPrice, label: "Sell Price" },
      { name: "quantity", value: formData.quantity, label: "Quantity" },
    ];

    // Find missing fields
    const missingFields = requiredFields.filter(
      (field) => !formData[field.name]
    );

    // Create errors for missing fields
    const errors = {};
    missingFields.forEach((field) => {
      errors[field.name] = "Required field.";
    });

    // If any required fields are missing, show the errors and stop
    if (missingFields.length > 0) {
      setFieldErrors(errors);
      setOpenSnackbar(true);

      const missingFieldsMessage = `Please fill in the following fields: ${missingFields
        .map((field) => field.label)
        .join(", ")}`;
      setErrorMessage(missingFieldsMessage);
      return;
    }

    // Clear previous errors
    setFieldErrors({});
    // Add the item to the table data
    const updatedTableData = [...tableData, formData];

    setTableData(updatedTableData);
    sessionStorage.setItem("stockTableData", JSON.stringify(updatedTableData));

    // Show success message
    setErrorMessage(""); // Clear the error message
    setOpenSnackbar(true); // Optionally show a success snackbar

    // Call handleClearClick to reset the form data after adding the item
    handleClearClickAdd();
  };

  // Updated Snackbar for error and success messages
  <Snackbar
    open={openSnackbar}
    autoHideDuration={6000}
    onClose={() => setOpenSnackbar(false)}
    anchorOrigin={{ vertical: "top", horizontal: "right" }}
  >
    <Alert
      onClose={() => setOpenSnackbar(false)}
      severity={errorMessage ? "error" : "success"}
      sx={{ width: "100%" }}
    >
      {errorMessage || "GRN Added Successfully!"}
    </Alert>
  </Snackbar>;

  // Remove row
  const handleRemoveRow = (index) => {
    const updatedTableData = tableData.filter((_, i) => i !== index);
    setTableData(updatedTableData);
    sessionStorage.setItem("stockTableData", JSON.stringify(updatedTableData));
  };

  const areRequiredFieldsFilled = () => {
    // List required fields with name, value, and label
    // Check if tableData is empty
    if (!tableData || tableData.length === 0) {
      setErrorMessage("Table data cannot be empty. Please add items.");
      setOpenSnackbar(true);
      return;
    }
    const requiredFields = [
      {
        name: "invoiceDate",
        value: formData.invoiceDate,
        label: "Invoice Date",
      },
      { name: "invoiceNo", value: formData.invoiceNo, label: "Invoice Number" },
      { name: "supplier", value: formData.SUPREFCODE, label: "Supplier" },
    ];

    // Find missing fields
    const missingFields = requiredFields.filter(
      (field) =>
        !field.value || (field.name === "supplier" && !formData.SUPREFCODE)
    );

    const errors = {};
    missingFields.forEach((field) => {
      errors[field.name] = "Required field.";
    });

    if (missingFields.length > 0) {
      setFieldErrors1(errors);
      setOpenSnackbar(true);
      const missingFieldsMessage = `Please fill in the following fields: ${missingFields
        .map((field) => field.label)
        .join(", ")}`;
      setErrorMessage(missingFieldsMessage);

      return false;
    }

    setFieldErrors1({});
    return true;
  };

  // Function to handle confirm click and API call
  const handleConfirmClick = async () => {
    handleDisable();

    if (!areRequiredFieldsFilled()) {
      return;
    }

    const formattedInvoiceDate =
      formData.invoiceDate && !isNaN(new Date(formData.invoiceDate).getTime())
        ? new Date(formData.invoiceDate).toISOString().split("T")[0]
        : null;

    if (!formattedInvoiceDate) {
      setErrorMessage("Invalid Invoice Date. Please provide a valid date.");
      setOpenSnackbar(true); // Show error snackbar
      return;
    }

    const payload = {
      COMPCODE,
      LOCCODE,
      RESTCODE,
      STS: CON_STATUS_ACTIVE,
      GRNNO: "",
      ENUSER: USERNAME,
      invoiceDate: formattedInvoiceDate,
      invoiceNo: formData.invoiceNo,
      ISNEWGRN: "y",
      SUPREFCODE: String(formData.SUPREFCODE),
      TAXAMT: tableData.reduce((acc, item) => {
        const GROSSAMT = parseFloat((item.quantity * item.cost).toFixed(2));
        const DISCOUNT_AMOUNT =
          (GROSSAMT * parseFloat(item.discount)) / 100 || 0;
        const TAX_AMOUNT =
          ((GROSSAMT - DISCOUNT_AMOUNT) * parseFloat(item.tax)) / 100 || 0;
        return acc + TAX_AMOUNT;
      }, 0),
      DISCOUNT: tableData.reduce((acc, item) => {
        const GROSSAMT = parseFloat((item.quantity * item.cost).toFixed(2));
        const DISCOUNT_AMOUNT =
          (GROSSAMT * parseFloat(item.discount)) / 100 || 0;
        return acc + DISCOUNT_AMOUNT;
      }, 0),
      NETTAMT: tableData.reduce((acc, item) => {
        const GROSSAMT = parseFloat((item.quantity * item.cost).toFixed(2)); // Gross Amount
        const DISCOUNT = isNaN(item.discount)
          ? 0
          : (GROSSAMT * item.discount) / 100; // Discount Amount
        const TAXABLE_AMOUNT = GROSSAMT - DISCOUNT; // Amount after discount
        const TAX = isNaN(item.tax) ? 0 : (TAXABLE_AMOUNT * item.tax) / 100; // Tax Amount
        const itemNETTAMT = parseFloat((TAXABLE_AMOUNT + TAX).toFixed(2)); // Net Amount
        return acc + itemNETTAMT; // Accumulate the Net Amount
      }, 0),
      GROSSAMT: tableData.reduce(
        (acc, item) => acc + parseFloat((item.quantity * item.cost).toFixed(2)),
        0
      ),
      // FILEPATH: filePath,
      StockDet: tableData.map((item) => ({
        MENUCATCODE: String(item.MENUCATCODE),
        MENUCODE: String(item.MENUCODE),
        RATE: parseFloat(item.cost),
        SELLINGRATE: parseFloat(item.sellPrice),
        EXPIRY:
          item.expiry && !isNaN(new Date(item.expiry))
            ? new Date(item.expiry).toISOString().split("T")[0]
            : "0001-01-01",

        // EXPIRY: new Date(item.expiry).toISOString().split("T")[0] || "0",
        QTY: parseFloat(item.quantity),
        NETTAMT:
          parseFloat(
            (
              parseFloat((item.quantity * item.cost).toFixed(2)) - // Gross Amount
              parseFloat(
                isNaN(item.discount)
                  ? 0
                  : (item.quantity * item.cost * item.discount) / 100 // Discount Amount
              ) +
              parseFloat(
                isNaN(item.tax)
                  ? 0
                  : ((item.quantity * item.cost - // Gross minus Discount
                      parseFloat(
                        isNaN(item.discount)
                          ? 0
                          : (item.quantity * item.cost * item.discount) / 100
                      )) *
                      item.tax) /
                      100 // Tax calculated on post-discount amount
              )
            ).toFixed(2)
          ) || 0,
        GROSSAMT: parseFloat((item.quantity * item.cost).toFixed(2)),
        DISCOUNT: parseFloat(
          isNaN(item.discount)
            ? 0
            : (item.quantity * item.cost * item.discount) / 100
        ),
        TAXAMT: parseFloat(
          isNaN(item.tax)
            ? 0
            : ((item.quantity * item.cost -
                parseFloat(
                  isNaN(item.discount)
                    ? 0
                    : (item.quantity * item.cost * item.discount) / 100
                )) *
                item.tax) /
                100
        ),
        STS: CON_STATUS_ACTIVE,
        // FILEPATH: item.filePath,
      })),
    };

    try {
      console.log("Payload for stock:", payload);

      const responseData = await externalpostApi(STOCK_API_01, payload);

      console.log("Success:", responseData);
      // setOpenSnackbar(true);
      setErrorMessage("");
      setOpenSnackbar(true);
      // Clear session storage only after a successful API call
      sessionStorage.clear();

      console.log("Session storage cleared!");
      handleClearClick();
      setTableData([]);
    } catch (error) {
      console.error("Error submitting stock data:", error);
      setErrorMessage("An error occurred while submitting the stock data.");
      setOpenSnackbar(true);
    }
  };

  // Retain all other fields
  const handleClearClick = () => {
    setFormData({
      invoiceNo: "",
      tax: "",
      discount: "",
      item: "",
      cost: "",
      sellPrice: "",
      expiry: "",
      quantity: "",
      // filepath: null,
    });
    setFieldErrors("");
  };

  const handleClearClickAdd = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      item: "",
      cost: "",
      sellPrice: "",
      expiry: "",
      quantity: "",
      tax: 0,
      discount: 0,
    }));
  };

  const gotToView = () => {
    navigate("/stockitemdet");
  };

  const fetchDatacustom = async () => {
    try {
      const result = await externalgetApi(CUSTOMER_API_01, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        CONTACTNO: "",
        FIRSTNAME: "",
        EMAIL: "",
        STS: CON_STATUS_ACTIVE,
      });
      setData(result);
      setIsLoading(false);
    } catch (err) {
      setError(err);
      setIsLoading(false);
    }
  };

  const fetchDataComman = async () => {
    try {
      const today = new Date();
      const formattedToday = `${today.getFullYear()}-${String(
        today.getMonth() + 1
      ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")} 23:59:59`;

      const result = await externalgetApi(COMMON_API_02, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        TODAY: formattedToday,
        STS: CON_STATUS_ACTIVE,
      });
      setData1(result);
    } catch (err) {
      console.error(err);
    }
  };
  // handlers
  const decimalRegex = /^\d+(\.\d{0,2})?$/;

  const handleInputChange = (field, value) => {
    // Validate input for decimal fields
    if (["cost", "sellPrice", "quantity"].includes(field) && value) {
      if (!decimalRegex.test(value)) {
        return; // Prevent invalid input
      }
    }

    // Handle empty input: set an error if field is empty after clearing
    if (value === "") {
      setFieldErrors((prevErrors) => ({
        ...prevErrors,
        [field]: "This field cannot be empty", // Set a dynamic error message
      }));
    } else {
      // Clear error if input is valid
      if (fieldErrors[field]) {
        setFieldErrors((prevErrors) => ({
          ...prevErrors,
          [field]: "", // Clear the error for this field
        }));
      }
    }

    // Update form data
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handlenumInputValidation1 = (event) => {
    const { id, value } = event.target;

    // Regular expression to allow only numbers and floats
    const regex = /^[0-9]*\.?[0-9]*$/;

    if (regex.test(value)) {
      setError1(""); // Clear any existing error message

      // Update state with the valid input
      setFormData((prevData) => ({
        ...prevData,
        [id]: value,
      }));

      // Clear any specific field error if validation passes
      setFieldErrors1((prevErrors) => ({
        ...prevErrors,
        [id]: "",
      }));
    } else {
      // Set error message if validation fails
      setError1("Only numbers and floats are allowed.");

      // Update the fieldErrors1 state to show the error for invoiceNo
      setFieldErrors1((prevErrors) => ({
        ...prevErrors,
        [id]: "Only numbers and floats are allowed.",
      }));
    }
  };

  const validateField = (fieldName, value) => {
    const errors = { ...fieldErrors };

    if (fieldName === "item") {
      if (!value) {
        errors[fieldName] = "Please select an item.";
      } else {
        delete errors[fieldName]; // Remove error if valid
      }
    }

    setFieldErrors(errors);
  };

  const handlenumInputValidation4 = (event) => {
    const { id, value } = event.target;

    // Regular expression to allow only numbers and floats
    const regex = /^[0-9]*\.?[0-9]*$/;

    // Remove leading zeros while keeping the decimal point intact
    const sanitizedValue = value.replace(/^0+(?!\.)/, "");

    // Parse the sanitized value as a float for comparison
    const numericValue = parseFloat(sanitizedValue);

    if (
      regex.test(sanitizedValue) &&
      (numericValue <= 100 || isNaN(numericValue))
    ) {
      setError4(""); // Clear any existing error message
      setFormData((prevData) => ({
        ...prevData,
        [id]: sanitizedValue, // Update state with the sanitized value
      }));
    } else if (!regex.test(sanitizedValue)) {
      setError4("Only numbers and floats are allowed."); // Set error message for invalid input
    } else if (numericValue > 100) {
      setError4("Tax cannot exceed 100."); // Set error message for value over 100
    }
  };

  const handlenumInputValidation5 = (event) => {
    const { id, value } = event.target;

    // Regular expression to allow only numbers and floats
    const regex = /^[0-9]*\.?[0-9]*$/;

    // Remove leading zeros while keeping the decimal point intact
    const sanitizedValue = value.replace(/^0+(?!\.)/, "");

    // Parse the value as a float for comparison
    const numericValue = parseFloat(sanitizedValue);

    if (
      regex.test(sanitizedValue) &&
      (numericValue <= 100 || isNaN(numericValue))
    ) {
      setError5(""); // Clear any existing error message
      setFormData((prevData) => ({
        ...prevData,
        [id]: sanitizedValue, // Update state with the valid input
      }));
    } else if (!regex.test(sanitizedValue)) {
      setError5("Only numbers and floats are allowed."); // Set error message for invalid input
    } else if (numericValue > 100) {
      setError5("Discount cannot exceed 100."); // Set error message for value over 100
    }
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Stock</Link>
                <Link underline="none">Add Stock</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack direction="row" justifyContent="flex-end">
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      <Box sx={styles.st_page_aside}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography
              sx={{
                ...theme.typography.h2,
                color: theme.palette.text.primary,
                pl: 2,
              }}
            >
              Stock
            </Typography>
          </Grid>
          {/* Form Section */}
          <Grid item xs={12} sm={12} md={4} mt={-2}>
            <Box
              p={2}
              sx={{ borderRight: `1px solid ${theme.palette.divider}` }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Autocomplete
                    id="supplier"
                    options={data || []} // Ensure options is never null
                    getOptionLabel={(option) => `${option.FIRSTNAME}`} // Display supplier name
                    onChange={(event, value) => {
                      setFormData((prev) => ({
                        ...prev,
                        SUPREFCODE: value ? value.SUPREFCODE : "", // Set SUPREFCODE from the selected option
                        FIRSTNAME: value ? value.FIRSTNAME : "", // Set FIRSTNAME from the selected option
                      }));

                      // Check if supplier is selected, if not, set an error
                      if (!value) {
                        setFieldErrors1((prevErrors) => ({
                          ...prevErrors,
                          supplier: "Supplier is required", // Error message
                        }));
                      } else {
                        setFieldErrors1((prevErrors) => ({
                          ...prevErrors,
                          supplier: "", // Clear error message when a valid supplier is selected
                        }));
                      }
                    }}
                    value={
                      data
                        ? data.find(
                            (option) =>
                              option.SUPREFCODE === formData.SUPREFCODE
                          ) || null // Set the selected value based on SUPREFCODE
                        : null
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Supplier"
                        required
                        size="small"
                        name="supplier"
                        fullWidth
                        error={!!fieldErrors1.supplier} // Show error if field has an error
                        helperText={fieldErrors1.supplier || ""} // Show error message for missing field or from validation
                      />
                    )}
                    ListboxProps={{
                      style: {
                        maxHeight: 150,
                        backgroundColor: theme.palette.background.paper,
                      },
                    }}
                    noOptionsText={
                      <div
                        style={{
                          backgroundColor: theme.palette.background.paper,
                          padding: "8px",
                        }}
                      >
                        No options
                      </div>
                    }
                  />
                </Grid>

                <Grid item xs={6}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Invoice Date"
                      value={
                        formData.invoiceDate
                          ? dayjs(formData.invoiceDate)
                          : null
                      }
                      onChange={(newValue) => {
                        const formattedDate = newValue
                          ? newValue.format("YYYY-MM-DD")
                          : "";

                        // Check for errors
                        if (!newValue || !newValue.isValid()) {
                          setFieldErrors1({
                            ...fieldErrors1,
                            invoiceDate:
                              "Invalid date selected. Please select a valid date.",
                          });
                        } else {
                          setFieldErrors1({
                            ...fieldErrors1,
                            invoiceDate: "", // Clear error when valid date is selected
                          });
                        }

                        setFormData({
                          ...formData,
                          invoiceDate: formattedDate,
                        });
                      }}
                      slotProps={{
                        textField: {
                          required: true,
                          error: !!fieldErrors1.invoiceDate, // Show error if there is an error
                          helperText: fieldErrors1.invoiceDate || "", // Display the error message
                          sx: {
                            width: "100%",
                            "& .MuiInputLabel-root": {
                              width: "100%",
                              top: "-20%",
                            },
                            "& .MuiInputBase-root": {
                              height: "40px",
                              display: "flex",
                              alignItems: "center",
                            },
                            "& .MuiInputAdornment-root .MuiIconButton-root": {
                              color: theme.palette.primary.main,
                            },
                          },
                        },
                        popper: {
                          sx: {
                            "& .MuiPaper-root": {
                              backgroundColor: theme.palette.background.default,
                              boxShadow: "none",
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    id="invoiceNo"
                    label="Invoice No."
                    variant="outlined"
                    required
                    fullWidth
                    size="small"
                    value={formData.invoiceNo}
                    onChange={handlenumInputValidation1} // Ensure this function validates the input correctly
                    // InputLabelProps={{ sx: { ...theme.typography.body2 } }}
                    error={!!fieldErrors1.invoiceNo} // Update to check the correct error key for invoiceNo
                    helperText={fieldErrors1.invoiceNo || error1 || ""} // Display the correct error message
                  />
                </Grid>
                <Grid item xs={6}></Grid>
                {/* <Grid item xs={6}>
                  <Button
                    component="label"
                    variant="contained"
                    startIcon={<CloudUploadIcon />}
                    sx={{ width: "100%" }}
                  >
                    File Upload
                    <input
                      type="file"
                      accept="image/*"
                      hidden
                      onChange={handleImageChange}
                    />
                  </Button>
                </Grid> */}

                {/* Divider after Invoice Date and Invoice No. */}
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Grid item xs={12}>
                  <Autocomplete
                    id="item"
                    options={
                      data1
                        ? data1.map(
                            (item) => `${item.MENUNAME}  (${item.MENUCODE})`
                          )
                        : []
                    }
                    value={formData.item}
                    onChange={(event, newValue) => {
                      const selectedItem = data1.find(
                        (item) =>
                          `${item.MENUNAME}  (${item.MENUCODE})` === newValue
                      );
                      setFormData({
                        ...formData,
                        item: newValue,
                        MENUCODE: selectedItem ? selectedItem.MENUCODE : "",
                        MENUCATCODE: selectedItem
                          ? selectedItem.MENUCATCODE
                          : "",
                        sellPrice: selectedItem ? selectedItem.ITEMRATE : "",
                      });
                      validateField("item", newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Item"
                        size="small"
                        required
                        fullWidth
                        error={!!fieldErrors.item} // Show error if field has an error
                        helperText={fieldErrors.item || ""} // Show error message for missing field or from validation
                        // InputLabelProps={{ sx: { ...theme.typography.body2 } }}
                      />
                    )}
                    ListboxProps={{
                      style: {
                        maxHeight: 150,
                        backgroundColor: theme.palette.background.paper,
                      },
                    }}
                    noOptionsText={
                      <div
                        style={{
                          backgroundColor: theme.palette.background.paper,
                          padding: "8px",
                        }}
                      >
                        No options
                      </div>
                    }
                  />
                </Grid>
                {/* <Grid item xs={6}>
                  <TextField
                    id="menucode"
                    label="Menu code"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formData.MENUCODE}
                    onChange={handleInputChange}
                    InputLabelProps={{ sx: { ...theme.typography.body2 } }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    id="menucatcode"
                    label="MenuCAT code"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formData.MENUCATCODE}
                    onChange={handleInputChange}
                    InputLabelProps={{ sx: { ...theme.typography.body2 } }}
                  />
                </Grid> */}

                <Grid item xs={12}>
                  <TextField
                    id="cost"
                    label="Cost"
                    type="text"
                    required
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formData.cost}
                    error={!!fieldErrors.cost} // Show error if field has an error
                    helperText={fieldErrors.cost || ""} // Show error message for missing field or from validation
                    // onChange={handleInputChange}
                    onChange={(e) => handleInputChange("cost", e.target.value)}
                    // InputLabelProps={{ sx: { ...theme.typography.body2 } }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    id="sellPrice"
                    label="Sell Price"
                    variant="outlined"
                    fullWidth
                    required
                    size="small"
                    value={formData.sellPrice}
                    onChange={(e) =>
                      handleInputChange("sellPrice", e.target.value)
                    }
                    error={!!fieldErrors.sellPrice}
                    helperText={fieldErrors.sellPrice || ""}
                  />
                </Grid>
                <Grid item xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Expiry"
                      value={formData.expiry ? dayjs(formData.expiry) : null} // Set to null instead of today
                      onChange={(newValue) => {
                        // Format the date to 'YYYY-MM-DD' to avoid time zone issues
                        const formattedDate = newValue
                          ? newValue.format("YYYY-MM-DD")
                          : "";
                        setFormData({
                          ...formData,
                          expiry: formattedDate, // Save as local date string
                        });
                      }}
                      inputFormat="MM/DD/YYYY"
                      minDate={dayjs()}
                      slotProps={{
                        textField: {
                          sx: {
                            width: "100%",
                            "& .MuiInputLabel-root": {
                              width: "100%",
                              top: "-20%",
                            },
                            "& .MuiInputBase-root": {
                              height: "40px",

                              display: "flex",
                              alignItems: "center",
                            },
                            "& .MuiInputAdornment-root .MuiIconButton-root": {
                              color: theme.palette.primary.main,
                            },
                          },
                        },
                        popper: {
                          sx: {
                            "& .MuiPaper-root": {
                              backgroundColor: theme.palette.background.default,
                              boxShadow: "none",
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    id="quantity"
                    label="Quantity"
                    variant="outlined"
                    fullWidth
                    required
                    size="small"
                    value={formData.quantity}
                    // onChange={handlenumInputValidation3}
                    onChange={(e) =>
                      handleInputChange("quantity", e.target.value)
                    }
                    error={!!fieldErrors.quantity} // Show error if field has an error
                    helperText={fieldErrors.quantity || ""} // Show error message for missing field or from validation
                    // InputLabelProps={{ sx: { ...theme.typography.body2 } }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    id="tax"
                    label="Tax(%)"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formData.tax || "0"}
                    onChange={handlenumInputValidation4}
                    error={!!error4}
                    helperText={error4}
                    InputLabelProps={{ sx: { ...theme.typography.body2 } }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    id="discount"
                    label="Discount(%)"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={formData.discount || "0"}
                    onChange={handlenumInputValidation5}
                    error={!!error5}
                    helperText={error5}
                    InputLabelProps={{ sx: { ...theme.typography.body2 } }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Button
                    sx={styles.btn_secondary}
                    size="medium"
                    variant="outlined"
                    onClick={handleClearClick}
                  >
                    Clear
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    sx={styles.btn_primary}
                    size="medium"
                    variant="contained"
                    onClick={handleAddClick}
                    // disabled={disabled}
                  >
                    Add
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* Table Section */}
          <Grid item xs={12} md={8} pr={1}>
            <Box p={1} sx={styles.st_page_table}>
              {/* <Grid
                item
                xs={12}
                md={4}
                sx={{
                  ml: {
                    xs: 5, 
                    sm: 10, 
                    md: 45,
                    lg: 75, 
                  },
                }}
                display="flex"
                justifyContent="flex-end"
              > */}
              <Box p={2} ml={-5}>
                <Box sx={styles.right_align}>
                  <Button
                    size="medium"
                    variant="contained"
                    onClick={handleConfirmClick}
                    disabled={disabled}
                    sx={{
                      ...styles.btn_primary,
                      // background: theme.palette.primary.main,
                      // color: theme.palette.text.buttontxt,
                      // textTransform: "capitalize",
                      // letterSpacing: "1px",
                      width: "80px",
                    }}
                  >
                    Confirm
                  </Button>
                </Box>

                {/* Snackbar for error and success messages */}
                <Snackbar
                  open={openSnackbar}
                  autoHideDuration={6000}
                  onClose={() => setOpenSnackbar(false)}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <Alert
                    onClose={() => setOpenSnackbar(false)}
                    severity={errorMessage ? "error" : "success"}
                    sx={{ width: "100%" }}
                  >
                    {errorMessage || "GRN Added Successfully!"}
                  </Alert>
                </Snackbar>
              </Box>
              {/* </Grid> */}
              <TableContainer component={Paper}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      {/* <TableCell>Supplier</TableCell>
                    <TableCell>Invoice Date</TableCell>
                    <TableCell>Invoice No.</TableCell> */}
                      <TableCell
                        sx={{
                          ...styles.AI_headtableCell,
                          fontWeight: "bold",
                          maxWidth: "100px",
                        }}
                      >
                        Item
                      </TableCell>
                      <TableCell
                        sx={{ ...styles.AI_headtableCell, fontWeight: "bold" }}
                        align="center"
                      >
                        Cost
                      </TableCell>
                      <TableCell
                        sx={{ ...styles.AI_headtableCell, fontWeight: "bold" }}
                        align="right"
                      >
                        Sell Price
                      </TableCell>
                      {/* <TableCell sx={{ fontWeight: "bold" }}>Expiry</TableCell> */}
                      <TableCell
                        sx={{ ...styles.AI_headtableCell, fontWeight: "bold" }}
                        align="right"
                      >
                        Qty
                      </TableCell>
                     
                     
                      <TableCell
                        sx={{ ...styles.AI_headtableCell, fontWeight: "bold" }}
                        align="right"
                      >
                        Gross Amt
                      </TableCell>
                       <TableCell
                        sx={{ ...styles.AI_headtableCell, fontWeight: "bold" }}
                        align="right"
                      >
                        Discount Amt
                      </TableCell>{" "}
                       <TableCell
                        sx={{ ...styles.AI_headtableCell, fontWeight: "bold" }}
                        align="right"
                      >
                        Tax
                      </TableCell>
                      <TableCell
                        sx={{ ...styles.AI_headtableCell, fontWeight: "bold" }}
                        align="right"
                      >
                        Net Amt
                      </TableCell>
                      
                      <TableCell
                        sx={{ ...styles.AI_headtableCell, fontWeight: "bold" }}
                      >
                        Actions
                      </TableCell>
                      {/* <TableCell
                        sx={{ ...styles.AI_headtableCell, fontWeight: "bold" }}
                      >
                        Upload
                      </TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData.map((row, index) => {
                      const GROSSAMT = parseFloat(
                        (row.quantity * row.cost).toFixed(2)
                      );

                      const DISCOUNT_AMOUNT =
                        parseFloat(
                          ((GROSSAMT * parseFloat(row.discount)) / 100).toFixed(
                            2
                          )
                        ) || 0;

                      // Calculate Tax Amount
                      const TAX_AMOUNT =
                        parseFloat(
                          (
                            ((GROSSAMT - DISCOUNT_AMOUNT) *
                              parseFloat(row.tax)) /
                            100
                          ).toFixed(2)
                        ) || 0;
                      const NETTAMT = parseFloat(
                        (GROSSAMT + TAX_AMOUNT - DISCOUNT_AMOUNT).toFixed(2)
                      );

                      return (
                        <TableRow key={index}>
                          {/* <TableCell>{row.supplier}</TableCell>
        <TableCell>{row.invoiceDate}</TableCell>
        <TableCell>{row.invoiceNo}</TableCell> */}
                          <TableCell
                            align="left"
                            sx={{
                              maxWidth: "100px",
                              overflow: "hidden", // Hide the overflowed text
                              whiteSpace: "nowrap", // Prevent text from wrapping to the next line
                              textOverflow: "ellipsis",
                            }}
                          >
                            <Tooltip title={row.item} arrow>
                              <span>{row.item}</span>
                            </Tooltip>
                          </TableCell>
                          <TableCell align="right">
                            {currencyFormat(row.cost)}
                          </TableCell>
                          <TableCell align="right">
                            {currencyFormat(row.sellPrice)}
                          </TableCell>
                          {/* <TableCell>{formatDate(row.expiry)}</TableCell> */}
                          <TableCell align="right">{row.quantity}</TableCell>
                          
                         
                          <TableCell align="right">
                            {currencyFormat(GROSSAMT)}
                          </TableCell>
                           <TableCell align="right">
                            {currencyFormat(DISCOUNT_AMOUNT)}
                          </TableCell>
                          <TableCell align="right">
                            {currencyFormat(TAX_AMOUNT)}
                          </TableCell>
                          <TableCell align="right">
                            {currencyFormat(NETTAMT)}
                          </TableCell>
                          <TableCell>
                            <Tooltip title="Delete" arrow>
                              <IconButton
                                onClick={() => handleRemoveRow(index)}
                              >
                                <DeleteIcon
                                  sx={{ color: theme.palette.system.danger }}
                                />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                          {/* <TableCell>
                            <Tooltip title="Upload" arrow>
                              <Button
                                component="label"
                                startIcon={<CloudUploadIcon />}
                              >
                                <input
                                  type="file"
                                  accept="image/*"
                                  hidden
                                  onChange={(event) => handleTempImageChange(event, index)}
                                />
                              </Button>
                            </Tooltip>
                          </TableCell> */}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
